import { render, staticRenderFns } from "./AzPersonsEdit.vue?vue&type=template&id=ee507912"
import script from "./AzPersonsEdit.vue?vue&type=script&lang=js"
export * from "./AzPersonsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports